<template>
  <div class="fullscreen">
    <div class="imageview" ref="container">
      <button class="modal-button" type="button" @click="closeWindow">
        <BaseIcon name="window-close" class="icon" />
      </button>
      <v-stage
        ref="stage"
        class="draw-area"
        :config="stageSize"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
        @mousemove="handleMouseMove"
      >
        <v-layer>
          <v-image
            :config="{
              image: image,
            }"
          ></v-image>
        </v-layer>

        <v-layer>
          <v-arrow
            v-for="arrow in this.arrows"
            :key="arrow.id"
            :config="{
              stroke: arrow.color,
              fill: arrow.color,
              points: arrow.points,
              tension: 1,
              pointerLength: 8,
              pointerWidth: 8,
              strokeWidth: 4,
            }"
          >
          </v-arrow>
          <v-text
            v-for="arrow in arrows"
            :key="arrow.chars"
            :config="{
              x: arrow.points[0],
              y: arrow.points[1] + 10,
              text: arrow.chars,
              fontSize: 16,
              fill: arrow.color,
            }"
          >
          </v-text>
        </v-layer>
        <v-layer ref="dragLayer"></v-layer>
      </v-stage>

      <div class="button-area">
        <div class="stage-tools">
          <BaseIcon
            name="undo-alt"
            class="icon"
            :class="{ inactive: hasNoOlderArrows }"
            size="lg"
            @click.native="undoArrow"
          />
          <BaseIcon
            name="redo-alt"
            class="icon"
            :class="{ inactive: hasNoNewerArrows }"
            size="lg"
            @click.native="redoArrow"
          />
        </div>
        <div class="stage-tools">
          <div
            class="colored-button final"
            :class="{ isSelected: isSelectedIPC == 'final' }"
            @click="toggleIPC('final')"
          >
            Final
          </div>
          <div
            class="colored-button ipc"
            :class="{ isSelected: isSelectedIPC == 'ipc' }"
            @click="toggleIPC('ipc')"
          >
            IPC
          </div>
        </div>
        <BaseButton
          color="primary"
          :key="2"
          type="button"
          size="modal-sm"
          @click.native="saveDrawings(true)"
        >
          Confirm
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";

export default {
  components: {
    BaseIcon,
    BaseButton,
  },

  props: {
    currentImage: Object,
  },
  data() {
    return {
      image: null,
      stageSize: {
        width: 0,
        height: 0,
      },
      img_width: 0,
      img_height: 0,
      ratio: 0,
      max: 850,
      drawningArrow: false,
      arrows: [],
      allArrows: [],
      hasNoOlderArrows: true,
      hasNoNewerArrows: true,
      isIPC: false,
      isSelectedIPC: "final",
    };
  },
  created() {
    window.addEventListener("resize", this.changeRect);
    this.changeRect();

    const image = new window.Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = this.currentImage.imageURL;
    image.onload = () => {
      this.image = image;
      this.calculateDimensions();
    };
  },
  mounted() {},
  methods: {
    changeRect: function () {
      const container = this.$refs.container;

      if (!container) {
        return;
      }

      const height = container.offsetHeight;
      const width = container.offsetWidth;

      this.stageSize.width = width;
      this.stageSize.height = height;
    },
    calculateDimensions() {
      this.img_width = this.image.width;
      this.img_height = this.image.height;

      this.ratio =
        this.img_width > this.img_height
          ? this.img_width / this.max
          : this.img_height / this.max;

      this.stageSize.width = this.img_width / this.ratio;
      this.stageSize.height = this.img_height / this.ratio;
    },
    toggleIPC(type) {
      this.isSelectedIPC = type;
      this.isIPC = type == "ipc" ? true : false;
    },
    handleMouseDown(e) {
      const { x, y } = e.target.getStage().getPointerPosition();
      this.drawningArrow = true;

      let amountOfArrows = this.arrows.length;
      let currentLetter = "";
      let alphabet = "abcdefghijklmnopqrstuvwxyz";
      let chars = "";

      if (amountOfArrows > 26) {
        let amountChar = Math.floor(amountOfArrows / 26);
        let firstChar = alphabet[amountChar];
        let secondChar = alphabet[amountOfArrows - amountChar * 26];

        chars = firstChar + secondChar;
      } else {
        chars = alphabet[amountOfArrows];
      }

      this.arrows.push({
        id: Date.now(),
        chars: chars,
        isIPC: this.isIPC,
        color: this.isIPC ? "#055FA3" : "#05A393",
        points: [x, y],
      });
    },
    handleMouseMove(e) {
      if (!this.drawningArrow) {
        return;
      }
      const pos = e.target.getStage().getPointerPosition();
      const lastLine = this.arrows[this.arrows.length - 1];
      lastLine.points = [lastLine.points[0], lastLine.points[1], pos.x, pos.y];
    },
    handleMouseUp(e) {
      const { x, y } = e.target.getStage().getPointerPosition();
      this.drawningArrow = false;
      const lastLine = this.arrows[this.arrows.length - 1];
      lastLine.points = [lastLine.points[0], lastLine.points[1], x, y];

      this.allArrows = this.arrows;
      this.hasNoOlderArrows = false;
    },
    undoArrow() {
      if (this.hasNoOlderArrows == false) {
        this.arrows = this.arrows.slice(0, -1);
        if (this.arrows.length == 0) {
          this.hasNoOlderArrows = true;
        }
        this.hasNoNewerArrows = false;
      }
    },
    redoArrow() {
      if (this.hasNoNewerArrows == false) {
        this.arrows.push(this.allArrows[this.arrows.length]);
        if (this.arrows.length == this.allArrows.length) {
          this.hasNoNewerArrows = true;
        }
        if (this.arrows.length != 0) {
          this.hasNoOlderArrows = false;
        }
      }
    },
    saveDrawings(bool) {
      var dataURL = this.$refs.stage
        .getStage()
        .toDataURL({ mimeType: "image/png", quality: 1 });
      var arrows = this.arrows;
      this.$emit("drawingComplete", { dataURL, arrows });
    },
    closeWindow() {
      this.$emit("closeDrawing", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

.fullscreen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba($color: #000000, $alpha: 0.16);

  display: flex;
  justify-content: center;
  align-items: center;

  .imageview {
    max-height: 95vh;
    max-width: 72vh;
    padding: 64px;
    background-color: white;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    .modal-button {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 32px;
      height: 32px;

      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      background-color: none;
      border: none;

      .icon {
        font-size: 18px;
        color: #d0d0d0;
      }

      &:hover {
        background-color: none;
        cursor: pointer;
        .icon {
          font-size: 18px;
          color: #6a6a6a;
        }
      }
    }

    .draw-area {
      border: #6a6a6a 1px dashed;
    }

    .button-area {
      margin-top: 16px;
      padding: 8px 0;
      width: 100%;

      display: flex;
      justify-content: space-between;
      align-items: center;

      .stage-tools {
        display: flex;
        align-items: center;

        .icon {
          margin-right: 16px;

          &.inactive {
            color: #c6c6c6 !important;

            &:hover {
              cursor: default;
            }
          }

          &:hover {
            cursor: pointer;
          }
        }

        .colored-button {
          font-weight: 500;
          border-radius: 8px;
          padding: 4px 8px;
          margin: 0 4px;
          user-select: none;

          &:hover {
            cursor: pointer;
          }

          &.ipc {
            border: 2px solid #055fa3;
            color: #055fa3;
            background-color: white;

            &.isSelected {
              background-color: #055fa3;
              color: white;
            }
          }
          &.final {
            border: 2px solid #05a393;
            color: #05a393;
            background-color: white;

            &.isSelected {
              background-color: #05a393;
              color: white;
            }
          }
        }
      }
    }

    .btn-close {
      position: absolute;
      top: 24px;
      right: 24px;
      width: 32px;
      height: 32px;

      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      background-color: none;
      border: none;

      .icon {
        font-size: 18px;
        color: #d0d0d0;
      }

      &:hover {
        background-color: none;
        cursor: pointer;
        .icon {
          font-size: 18px;
          color: #6a6a6a;
        }
      }
    }

    img {
      height: 64vh;
    }
  }
}
</style>